CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Membership = require 'models/membership'

module.exports = class MembershipList extends CollectionWithHelpers
  model: Membership

  initialize: ->
    @memberIndex = {}

    @listenTo @, 'add', (model) =>
      @memberIndex[model.get('idMember')] = model

    @listenTo @, 'remove', (model) =>
      delete @memberIndex[model.get('idMember')]

    @listenTo @, 'reset', =>
      @memberIndex = {}
      for membership in @models
        @memberIndex[membership.get('idMember')] = membership

  getMember: (member) ->
    idMember = member?.id ? member
    @memberIndex[idMember]



// WEBPACK FOOTER //
// ./app/scripts/models/collections/membership-list.coffee